// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3kupx","additionalInfo":"AgreementModal_additionalInfo__3xd6_"};